import mapApi from './mapApi';
import './map.css';
import './images/clusterer.png';
import './images/pointer.png';
import MapFilters from './MapFilters';

export default new class Map {
    constructor() {
        this.map = {};
        this.zoomControl;
        this.geoObjects;
        this.clusterers;
        this.clusterersIconLayout;
        this.balloonLayout;
        this.balloonContentLayout;
        this.customBalloonContentLayout;

        this.btnRegion = '.btn-region';
        this.mapCenter = [53.9, 27.5667];
        this.mapZoom = 11;

        this.mapWrapper = '#map-for-catalog';
        this.opened = '_opened';

        this.mapItemsData = {};
        this.productsLength = null;

        this.firstRender = true;
        this.balloonOpenResolutionFlag = true;

        this.scrollZoomHandler();
    }

    getCenter() {
        let $btnRegion = $(this.btnRegion),
            lat = $btnRegion.attr('data-lat'),
            lng = $btnRegion.attr('data-lng');
        if($btnRegion && lat && lng) {
            this.mapCenter = [parseFloat(lat.trim()), parseFloat(lng.trim())];
        }
        return this.mapCenter;
    }

    getData(callback, options) {

        if(!options.ajaxData) {
            ymaps.ready(callback);
            return;
        }

        let ajaxData = options.ajaxData,
            {mapApiName, data} = ajaxData;

        mapApi[mapApiName](data).then(res => {
            this.mapItemsData = res;
            ymaps.ready(callback);
        });
    }

    /**
     * options.noScroll - scroll при старте карты
     * options.balloonOpenResolutionFlag - разрешение открывать balloons
     * options.ajaxData: {data: {}, mapApiName}
     * @param options
     */
    mapInit(options) {
        let mapForCatalog = $(this.mapWrapper);
        if(mapForCatalog.length > 0) {
            this.balloonOpenResolutionFlag = options.balloonOpenResolutionFlag;
            this.getData(this.createMap.bind(this, options), options);
        }
    }

    createMap(options) {
        if(Object.keys(this.map).length) {
            this.map.destroy();
        }

        this.map = new ymaps.Map(this.mapWrapper.slice(1), {
            center: this.getCenter(),
            zoom: this.mapZoom,
            controls: []
        });
        //this.checkZoom();
        this.initControls(options);
        this.balloonLayoutCreate();
        MapFilters.filter(true);
        // this.mapsItems(this.mapItemsData);
        this.closeBalloon();
    }

    initControls(options) {
        if(options && options.noScroll) {
            this.map.behaviors.disable('scrollZoom');
        }
        this.zoomControl = new ymaps.control.ZoomControl({
            options: {
                size: 'small',
                position: {left: 20, top: 300}
            }
        });
        this.map.controls.add(this.zoomControl);
    }

    mapsItems(mapItemsData) {

        if(!$(this.mapWrapper).length) return;

        this.geoObjects = [];
        for(let i in mapItemsData) {
            this.productsLength = Object.keys(mapItemsData[i].products).length;
            let placemarkLayout = ymaps.templateLayoutFactory.createClass(`
            <div class="placemark-layout-container">
                <div class="placemark-layout">от ${mapItemsData[i]['price']}</div>
            </div>
            `),
                optionsForBalloon = {};

            if(this.balloonOpenResolutionFlag) {
                optionsForBalloon = {
                    balloonLayout: this.balloonLayout,
                    balloonContentLayout: this.balloonContentLayout,
                    hideIconOnBalloonOpen: false,
                    iconLayout: placemarkLayout,
                    iconShape: {
                        type: 'Rectangle',
                        coordinates: [
                            [-40, -35], [40, 0]
                        ]
                    },
                    openBalloonOnClick: true
                };
            } else {
                optionsForBalloon = {
                    balloonLayout: this.balloonLayout,
                    balloonContentLayout: this.balloonContentLayout,
                    hideIconOnBalloonOpen: false,
                    iconLayout: 'default#image',
                    iconImageHref: '/themes/arenda/assets/img/pointer.png',
                    iconImageSize: [34, 45],
                    iconImageOffset: [-17, -42],
                    cursor: 'default',
                    openBalloonOnClick: false
                };
            }

            this.geoObjects.push(new ymaps.Placemark(mapItemsData[i]['cord'], {
                balloonContent: this.balloonContentCreate(mapItemsData[i])
            }, optionsForBalloon));
        }

        this.clustererCreate();
    }

    balloonContentCreate(mapItemData) {
        let content = '',
            timeWork = mapItemData.work_time,
            week = mapItemData.week,
            today = mapItemData.today;

        for(let i in mapItemData.products) {
            content += `
            <div class="balloon-item-block${this.productsLength == 1 ? ` ${this.opened}` : ''}">
                <div class="balloon-item-block-top">
                    ${mapItemData.products[i].available_date ? `<div class="balloon-item-block__rent-message">Аренда доступна с ${mapItemData.products[i].available_date}</div>` : ''}
                     ${mapItemData.products[i].img ? `<img class="balloon-item-block__img" src="${mapItemData.products[i].img.path}" alt="">`: ''}
                    <div class="balloon-item-block__content">
                        <div class="balloon-item-block__content__category">${mapItemData.products[i].category}</div>
                        <div class="balloon-item-block__content__name">${mapItemData.products[i].name}</div>
                    </div>
                    <div class="balloon-item-block__price">${mapItemData.products[i].price} р/сутки</div>
                </div>
                <div class="balloon-item-block-bottom" style="${this.productsLength == 1 ? 'display: block;' : ''}">
                    <div class="balloon-item-block__description">${mapItemData.products[i].description}</div>
                    <div class="balloon-item-block__bottom">
                        <div class="balloon-item-block__bottom-inner">
                            <div class="balloon-item-block__bottom__left">
                                <div class="balloon-item-block__bottom__left__address">${mapItemData.address}</div>
                                <div class="balloon-item-block__bottom__left__rating">
                                    <ul class="star-rating-static">
                                        <li class="star-rating-static__item ${mapItemData.rating >= 1 ? 'star-rating-static__item_selected' : ''}"></li>
                                        <li class="star-rating-static__item ${mapItemData.rating >= 2 ? 'star-rating-static__item_selected' : ''}"></li>
                                        <li class="star-rating-static__item ${mapItemData.rating >= 3 ? 'star-rating-static__item_selected' : ''}"></li>
                                        <li class="star-rating-static__item ${mapItemData.rating >= 4 ? 'star-rating-static__item_selected' : ''}"></li>
                                        <li class="star-rating-static__item ${mapItemData.rating >= 5 ? 'star-rating-static__item_selected' : ''}"></li>
                                    </ul>
                                </div>
                                ${mapItemData.legal ? '<div class="balloon-item-block__bottom__left__legal">Только для юр. лиц</div>' : ''}
                            </div>
                            <div class="balloon-item-block__bottom__right">
                                <div class="balloon-item-block__bottom__right__work-time-link">
                                    <span>Время работы</span>
                                    <div class="balloon-item-block__bottom__right__work-time-link__pop-up">
                                        ${weekRender(week, today)}
                                    </div>
                                </div>
                                <div class="balloon-item-block__bottom__right__work-time">${timeWork}</div>
                            </div>
                        </div>
                        <div class="balloon-item-block__bottom__to-rent">
                            <a href="${mapItemData.products[i].href}" class="btn balloon-item-block__bottom__to-rent__btn">Взять в аренду</a>
                        </div>
                    </div>
                </div>
            </div>
            `;
        }

        function weekRender(week, today) {
            let weekContent = '';
            
            for(let i = 1; i <= 6; i++) {
                weekContent += `<div class="balloon-item-block__bottom__right__work-time-link__pop-up__day ${i == today ? '_active' : ''}">${week[i]}</div>`;
            }

            weekContent += `<div class="balloon-item-block__bottom__right__work-time-link__pop-up__day ${0 == today ? '_active' : ''}">${week[0]}</div>`;
            return weekContent;
        }

        return content;
    }

    balloonLayoutCreate() {
        let Map = this;
        this.balloonLayout = ymaps.templateLayoutFactory.createClass(`
            <div class="balloon-layout">
                <div class="balloon-layout-arrow"></div>
                <div class="balloon-layout-inner">$[[options.contentLayout]]</div>
            </div>
            `, {
                build: function () {
                    this.constructor.superclass.build.call(this);

                    this._$element = $('.balloon-layout', this.getParentElement());
                    this.el  = document.querySelector('.balloon-layout');

                    this.applyElementOffset();
                    this._openItemInPopup(this._$element);
                    this._noScrollForWindows(this._$element);
                    this._addCustomScroll();
                    this._openNewPage(this._$element);
                },
                onSublayoutSizeChange: function () {
                    this.balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                    if(!this._isElement(this._$element)) {
                        return;
                    }

                    this.applyElementOffset();

                    this.events.fire('shapechange');
                },
                applyElementOffset: function () {
                    this._$element.css({
                        right: parseInt(this._$element.find('.balloon-layout-arrow').css('border-top-width')) * 2,
                        top: - (this._$element[0].offsetHeight / 2)
                    });
                },
                getShape: function () {
                    if(!this._isElement(this._$element)) {
                        return this.balloonLayout.superclass.getShape.call(this);
                    }

                    let position = {left: this.el.offsetLeft, top: this.el.offsetTop};

                    return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                        [position.left, position.top], [
                            position.left + this._$element.width() + parseInt(this._$element.find('.balloon-layout-arrow').css('border-left-width')),
                            position.top + this._$element.height()
                        ]
                    ]));
                },
                _openNewPage: function(element) {
                    element.find('.balloon-item-block__bottom__to-rent__btn').on('click', e => {
                        let $this = $(e.currentTarget),
                            _href = $this.attr('href');
                        location.href = _href;
                    });
                },
                _isElement: function (element) {
                    return element && element[0] && element.find('.balloon-layout-arrow')[0];
                },
                _openItemInPopup: function(element) {
                    element.on('click', '.balloon-item-block', (e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        $('.balloon-item-block-bottom').stop().slideUp(400, 'linear');
                        let _target = $(e.target);

                        if(!_target.hasClass('balloon-item-block')) {
                            _target = _target.closest('.balloon-item-block');
                        }

                        $('.balloon-item-block').removeClass(Map.opened);
                        _target.addClass(Map.opened);
                        
                        _target.find('.balloon-item-block-bottom').stop().slideDown({
                            step: () => {
                                this.applyElementOffset(true);
                            },
                            duration: 400,
                            easing: 'linear',
                            complete: () => {
                                this._addCustomScroll();
                            }
                        });

                    });
                },
                _noScrollForWindows: function(element) {
                    let balloonLayoutInner = element.find('.balloon-layout-inner');
                    balloonLayoutInner.on('mouseenter', function () {
                        $('html,body').on('mousewheel', function (e) {
                            e.preventDefault();
                        });
                        balloonLayoutInner.on('mousewheel', function (e) {
                            var step = 15;
                            var direction = e.originalEvent.deltaY > 0 ? 1 : -1;
                            $(this).scrollTop($(this).scrollTop() + step * direction);
                        });
                    });
                    balloonLayoutInner.on('mouseleave', function () {
                        $('html,body').off('mousewheel');
                    });
                },
                _addCustomScroll() {
                    if(this._$element.height() >= 400) {
                        $('.balloon-layout-inner').mCustomScrollbar();
                    }
                }
            });

        this.balloonContentLayout = ymaps.templateLayoutFactory.createClass(
            `<h3 class="balloon-layout-title">$[properties.balloonHeader]</h3>
            <div class="balloon-layout-content">$[properties.balloonContent]</div>`
        );

        this.customBalloonContentLayout = ymaps.templateLayoutFactory.createClass(`
            <ul class=list>
            {% for geoObject in properties.geoObjects %}
                {{ geoObject.properties.balloonContent|raw }}
            {% endfor %}
            </ul>
            `);
    }

    clustererCreate() {
        this.clusterersIconLayout = ymaps.templateLayoutFactory.createClass(`
            <div class="clusterers-icon"">{{ properties.geoObjects.length }}</div>
        `);

        this.clusterers = new ymaps.Clusterer({
            preset: 'islands#invertedVioletClusterIcons',
            clusterIcons: [{
                href: '/themes/arenda/assets/img/clusterer.png',
                size: [35, 35],
                offset: [-17.5, -17.5]
            }],
            margin: [20],
            clusterNumbers: [10],
            clusterIconContentLayout: this.clusterersIconLayout,
            hideIconOnBalloonOpen: false,
            clusterBalloonLayout: this.balloonLayout,
            clusterBalloonContentLayout: this.customBalloonContentLayout,
            openBalloonOnClick: this.balloonOpenResolutionFlag ? true : false
        });

        this.clusterers.add(this.geoObjects);
        this.map.geoObjects.add(this.clusterers);

        this.findZoom(this.geoObjects);
        this.firstRender = false;
    }

    closeBalloon() {
        this.map.events.add('click', e => {
            this.map.balloon.close();
        });
    }

    checkZoom() {
        this.map.zoomRange.events.add('change', (e) => {
            this.clusterers.options.set({maxZoom: e.get('newZoomRange')[1] - 1});
        });
    }

    clearMap() {
        this.map.geoObjects.removeAll();
    }

    deleteMap() {
        if(Object.keys(this.map).length) {
            this.map.destroy();
        }
        this.firstRender = true;
    }

    scrollZoomHandler() {
        $(document).on('click', () => {
            if(Object.keys(this.map).length) {
                this.map.behaviors.disable('scrollZoom');
            }
        });

        $(document).on('click', this.mapWrapper, (e) => {
            e.stopPropagation();
            this.map.behaviors.enable('scrollZoom');
        });
    }

    findZoom(points) {
        let speed = 0;

        if(ymaps.geoQuery(points).searchIntersect(this.map).getLength() >= points.length) {
            return;
        }

        if(!this.firstRender) {
            speed = 300;
        }

        if(points.length == 1) {
            this.map.setCenter(points[0].geometry._coordinates, this.mapZoom, {duration: speed});
        }
        else if(points.length > 1) {
            this.map.setBounds(this.map.geoObjects.getBounds(), {duration: speed});
        }
    }

};


// WEBPACK FOOTER //
// ./src/common/modules/MapClasses/Map.js